<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Configuracion fiscal</h2>
  </div>

  <mat-card class="table-card setting-card">
    <div class="card-intro">
      <h3>Datos fiscales y numeracion</h3>
      <p>Gestiona tickets y facturas de local, online y rectificativas. La numeracion corresponde siempre al siguiente numero disponible.</p>
    </div>

    <form [formGroup]="settingFiscalForm" class="settings-groups">
      <section class="settings-group-card" *ngFor="let group of settingGroups; trackBy: trackByGroupTitle">
        <div class="settings-group-header">
          <div>
            <h4>{{ group.title }}</h4>
            <p>{{ group.description }}</p>
          </div>
        </div>

        <div class="settings-group-body" [class.with-preview]="group.previewLabel">
          <div class="form-grid compact-grid" [class.single-field-grid]="group.fields.length === 1">
            <ng-container *ngFor="let field of group.fields; trackBy: trackByControlName">
              <ng-container *ngIf="isDynamicField(field); else standardField">
                <div class="compact-field full-span dynamic-field">
                  <app-config-field
                    [config]="buildFieldConfig(field)"
                    [value]="settingFiscalForm.get(field.controlName)?.value"
                    (valueChange)="onDynamicFieldValueChange(field, $event)">
                  </app-config-field>
                </div>
              </ng-container>
              <ng-template #standardField>
                <mat-form-field
                  appearance="outline"
                  class="compact-field"
                  [class.series-field]="field.controlName.toLowerCase().includes('series')"
                  [class.number-field]="field.controlName.toLowerCase().includes('number')"
                  [class.full-span]="field.inputType === 'textarea'">
                  <mat-label>{{ field.label }}</mat-label>
                  <ng-container [ngSwitch]="field.inputType">
                    <textarea
                      *ngSwitchCase="'textarea'"
                      matInput
                      rows="4"
                      [formControlName]="field.controlName"
                      [placeholder]="field.placeholder"></textarea>
                    <input
                      *ngSwitchDefault
                      matInput
                      [type]="field.inputType"
                      [formControlName]="field.controlName"
                      [placeholder]="field.placeholder">
                  </ng-container>
                  <mat-hint>{{ field.description }}</mat-hint>
                  <mat-error *ngIf="hasError(field.controlName, 'required')">Este campo es obligatorio.</mat-error>
                  <mat-error *ngIf="hasError(field.controlName, 'min')">El valor debe ser mayor o igual que 1.</mat-error>
                  <mat-error *ngIf="hasError(field.controlName, 'max')">El valor supera el limite permitido.</mat-error>
                  <mat-error *ngIf="hasError(field.controlName, 'maxlength')">El texto supera la longitud maxima permitida.</mat-error>
                </mat-form-field>
              </ng-template>
            </ng-container>
          </div>

          <div class="settings-group-preview inline-preview" *ngIf="group.previewLabel">
            <span>{{ group.previewLabel }}</span>
            <strong>{{ getGroupPreview(group) }}</strong>
          </div>
        </div>
      </section>
    </form>

    <div class="page-actions">
      <button
        mat-raised-button
        color="primary"
        class="btn-round"
        [disabled]="saving"
        (click)="saveSettings()">
        <mat-icon>save</mat-icon>
        Guardar configuracion
      </button>
    </div>
  </mat-card>
</div>
